<template>
  <div class="orderList">
    <div v-for="item in orderList">
		<div class="orderItem" v-if="item.add_ip!='128'">
		  <div>
			<img src="../assets/orderIcon.png" alt="">
			<div>
			  <p>个人征信报告</p>
			  <p>{{ item.createtimetxt }}</p>
			</div>
		  </div>
		  <div class="pointer" @click="lookOrder(item)">立即查看</div>
		</div>
		<div class="orderItem" v-else>
		  <div>
			<img src="../assets/orderIcon.png" alt="">
			<div>
			  <p>法院信息高级版</p>
			  <p>{{ item.createtimetxt }}</p>
			</div>
		  </div>
		  <div class="pointer" @click="lookOrder_gaoji(item)">立即查看</div>
		</div>
    		
    </div>
	
    <div class="orderNull" v-if="orderList.length===undefined||orderList.length<=0">
      <img src="../assets/orderNull.png" alt="" >
      <p>抱歉,暂无查询记录!快去查询吧</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderList",
  data() {
    return {
      orderList: []
    }
  },
  created() {
    const storage = window.sessionStorage;
    this.$http.post("port/search/order_haspay_list", {
      token: storage.getItem("token")
    }).then((response) => {
      if (response.data.code === 0) {
        this.$message({
          message: response.data.msg,
          type: 'error'
        });
      } else {
        this.orderList = response.data.data.list;
      }
    })
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#F9F9F9')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    lookOrder(item) {
      const storage = window.sessionStorage;
      window.open("https://zxh1.xinzxing.cn/index/#/pages/info/info?id=" + item.id+"&token="+storage.getItem("token"), "_blank");
    },
	
	lookOrder_gaoji(item) {
	  const storage = window.sessionStorage;
	  window.open("https://zxh1.xinzxing.cn/index/#/pages/gaojiinfo/gaojiinfo?id=" + item.id+"&token="+storage.getItem("token"), "_blank");
	}
  }
}
</script>

<style>

.orderList {
  padding-top: 40px;
  box-sizing: border-box;
}

.orderItem {
  margin: 0 200px 40px;
  padding: 40px 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

.orderItem > div {
  display: flex;
  flex-direction: row;
}

.orderItem > div > img {
  width: 115px;
  height: 115px;
  margin-right: 38px;
}

.orderItem > div > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.orderItem > div > div > p:nth-child(1) {
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 12px 0;
}

.orderItem > div > div > p:nth-child(2) {
  font-size: 24px;
  color: #999999;
  margin: 0;
}

.orderItem > div:nth-child(2) {
  background: #348BFF;
  border-radius: 45px;
  padding: 10px 12px;
  box-sizing: border-box;
  font-size: 24px;
  color: #FFFFFF;
}


.orderNull {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #999999;
  margin-top: 100px;
}

.orderNull > img {
  width: 375px;
  height: 333px;
  margin-bottom: 60px;
}

</style>